<div class="page-contents">
  <div class="subBlockContainer">
    <div class="breadcrumbWrapper">
      <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="blockContainer flexbox-style-one" id='levelOne'>
      <div class="combination-loader">
        <!-- Showing cart names -->
        <div class="child-sidebar">
          <child-header [title]="title"  (closeEvent)="navigateTo('/home')"></child-header>
          <div class="page-title-wrapper" style="display: none;">
            <div class="title blade-title-font">
              {{title}}
            </div>
            <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/home']">close</i>
          </div>
          <loading-screen *ngIf="!loadContent" [showInnerLoading]="false" backDropWidth="250"
          (currentLoadingStatus)="onLoading($event)"></loading-screen>
          <div *ngIf="loadContent" class="child-body">
            <div id="finance-filter" class="menu-wrapper">
              <div class="searchInputGroup">
                <div class="searchIcon search-carts">
                  <img src="../images/new_ui/filter.png">
                </div>
                <input #searchInput class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchText" (ngModelChange)="filterShoppingCarts()">
              </div>
            </div>
            <ng-container *ngIf="shoppingCarts">
              <ng-container *ngFor="let item of shoppingCartsFilter">
                <div class="menu-wrapper menu-wrapper-small" [routerLink]="'summary/'+ item.cartId+'/'+item.cartName" routerLinkActive="active">
                  <div class="total-div">
                    <div class="narrow-title">{{item?.cartName}}</div>
                    <span class="narrow-text">Total Items: {{item?.totalQuantity}} |</span>
                    <span class="narrow-text"> Subtotal:
                      {{item?.totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <div>
              <vertical-banner [bannerLocation]="'finance'"></vertical-banner>
            </div>
          </div>
        </div>
        <div class="child-loader">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>